/**
 * Generato automaticamente.
 * framework-cmp-domande
 */
import { useQuery } from 'react-query';
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from 'react-query';
import { apiClientRequest } from '../../../client/apiClient';
import type { ErrorType } from '../../../client/apiClient';
import type {
  GetFrontImmaginiAltParams,
  MetadatiAltImmaginiDTO,
} from '.././schemas';

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

// eslint-disable-next-line
type SecondParameter<T extends (...args: any) => any> = T extends (
  config: any,
  args: infer P,
) => any
  ? P
  : never;

/**
 * Restituisce l'elenco dei testi alternativi delle immagini fornite in input per la lingua indicata
 * @summary Elenco testi alternativi Immagini Frontoffice
 */
export const getFrontImmaginiAlt = (
  params: GetFrontImmaginiAltParams,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<MetadatiAltImmaginiDTO>(
    {
      url: `/framework-cmp-domande/immagini/alt`,
      method: 'get',
      params,
      signal,
    },
    options,
  );
};

export const getGetFrontImmaginiAltQueryKey = (
  params: GetFrontImmaginiAltParams,
) =>
  [`/framework-cmp-domande/immagini/alt`, ...(params ? [params] : [])] as const;

export const getGetFrontImmaginiAltQueryOptions = <
  TData = Awaited<ReturnType<typeof getFrontImmaginiAlt>>,
  TError = ErrorType<unknown>,
>(
  params: GetFrontImmaginiAltParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getFrontImmaginiAlt>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryOptions<
  Awaited<ReturnType<typeof getFrontImmaginiAlt>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetFrontImmaginiAltQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getFrontImmaginiAlt>>
  > = ({ signal }) => getFrontImmaginiAlt(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions };
};

export type GetFrontImmaginiAltQueryResult = NonNullable<
  Awaited<ReturnType<typeof getFrontImmaginiAlt>>
>;
export type GetFrontImmaginiAltQueryError = ErrorType<unknown>;

/**
 * @summary Elenco testi alternativi Immagini Frontoffice
 */
export const useGetFrontImmaginiAlt = <
  TData = Awaited<ReturnType<typeof getFrontImmaginiAlt>>,
  TError = ErrorType<unknown>,
>(
  params: GetFrontImmaginiAltParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getFrontImmaginiAlt>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetFrontImmaginiAltQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};
